const DEFAULT_API_ENDPOINT = "https://api.ezasu.com/api/v1";

const apiBaseUrl = (
  "https://api.ezasu.com/api/v1" || DEFAULT_API_ENDPOINT
).replace(/\/+$/, "");

const appConfig = {
  apiBaseUrl,
  pdfBaseUrl: `${apiBaseUrl}/bucket/catalogues/`,
  authenticatedEntryPath: "/app/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/app/account/kyc-form",
  enableMock: false,
};

export default appConfig;
